/**
 * @file V1 fallback for the additional documents upload page.
 *
 * Uses the legacy FileField upload component instead of `va-file-input-multiple`.
 * Shown when the evidence enhancement toggle is ON but the FileInputV3 toggle
 * is OFF. Once FileInputV3 is fully rolled out, this page can be removed.
 */
import React from 'react';
import fullSchema from 'vets-json-schema/dist/21-526EZ-ALLCLAIMS-schema.json';
import { standardTitle } from '../../content/form0781';
import { additionalSupportAccordion } from '../../../shared/content/supportingEvidenceOrientation';
import {
  evidenceChoiceAdditionalDocumentsTitle,
  evidenceChoiceAdditionalDocuments,
} from '../../../shared/content/evidenceChoiceAdditionalDocumentsPage';
// import { uiSchema as legacyUiSchema } from '../../../all-claims/pages/additionalDocuments';
import { v1FileInputUiSchema } from './fileInputComponentV1';
import {
  LABEL,
  HINT_TEXT,
} from '../../../shared/components/fileInputComponent/FileInputComponentV1';

const { attachments } = fullSchema.properties;

/** @type {import('@rjsf/core').UiSchema} */
export const uiSchema = {
  'ui:title': standardTitle(evidenceChoiceAdditionalDocumentsTitle),
  'ui:description': () => (
    <div className="vads-u-margin-bottom--2">
      {evidenceChoiceAdditionalDocuments}
    </div>
  ),
  'ui:order': ['additionalDocuments', 'view:additionalSupportAccordionV1'],
  additionalDocuments: v1FileInputUiSchema({
    label: LABEL,
    additionLabel: 'Adding additional evidence:',
    description: HINT_TEXT,
  }),
  'view:additionalSupportAccordionV1': {
    'ui:description': additionalSupportAccordion,
  },
};

/** @type {import('@rjsf/core').JSONSchema7} */
export const schema = {
  type: 'object',
  required: ['additionalDocuments'],
  properties: {
    additionalDocuments: { ...attachments, minItems: 1 },
    'view:additionalSupportAccordionV1': { type: 'object', properties: {} },
  },
};
